//! PLOP_APPEND_TYPES

export const FETCH_ACTIVE_USER_START = 'FETCH_ACTIVE_USER_START';
export const FETCH_ACTIVE_USER_SUCCESS = 'FETCH_ACTIVE_USER_SUCCESS';
export const FETCH_ACTIVE_USER_FAILED = 'FETCH_ACTIVE_USER_FAILED';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const CHECK_ID_START = 'CHECK_ID_START';
export const CHECK_ID_SUCCESS = 'CHECK_ID_SUCCESS';
export const CHECK_ID_FAILED = 'CHECK_ID_FAILED';

export const UPDATE_USER_FIELDS_START = 'UPDATE_USER_FIELDS_START';
export const UPDATE_USER_FIELDS_SUCCESS = 'UPDATE_USER_FIELDS_SUCCESS';
export const UPDATE_USER_FIELDS_FAILED = 'UPDATE_USER_FIELDS_FAILED';

export const HANDLE_TWO_FACTOR_START = 'HANDLE_TWO_FACTOR_START';
export const HANDLE_TWO_FACTOR_SUCCESS = 'HANDLE_TWO_FACTOR_SUCCESS';
export const HANDLE_TWO_FACTOR_FAILED = 'HANDLE_TWO_FACTOR_FAILED';
